import {NgModule} from '@angular/core';
import {DecimalPipe} from '@angular/common';

import {FeatureRoutingModule} from './feature-routing.module';
import {RootComponent} from './components/root/root.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {AuthenticationComponent} from './components/authentication/authentication.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  NbBadgeModule,
  NbCardModule,
  NbIconModule,
  NbLayoutModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTagModule,
  NbToggleModule
} from '@nebular/theme';
import {RecaptchaModule} from 'ng-recaptcha';
import {CoreModule} from 'src/app/core/core.module';
import {UsersComponent} from './components/users/users.component';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {DateFormatPipe} from '../shared/pipes/jdate.pipe';
import {UserEditComponent} from './components/user-edit/user-edit.component';
import {TransactionsComponent} from './components/transactions/transactions.component';
import {FeeComponent} from './components/fee/fee.component';
import {NgChartsModule} from 'ng2-charts';
import {
  TwoFactorAuthenticationComponent
} from './components/two-factor-authentication/two-factor-authentication.component';
import {WelcomeComponent} from './components/welcome/welcome.component';
import {TableModule} from "primeng/table";
import {
  ReconciliationUserTransactionComponent
} from "./components/user-edit/components/contradiction/reconciliation-user-transaction.component";
import { ImpersonateTutorialComponent } from './components/user-edit/components/impersonate-tutorial/impersonate-tutorial.component';
import { ReportModule } from './modules/report/report.module';

@NgModule({
  declarations: [
    RootComponent,
    AuthenticationComponent,
    UsersComponent,
    UserEditComponent,
    ReconciliationUserTransactionComponent,
    TransactionsComponent,
    FeeComponent,
    TwoFactorAuthenticationComponent,
    WelcomeComponent,
    ImpersonateTutorialComponent
  ],
  imports: [
    FeatureRoutingModule,
    SharedModule,
    FormsModule,
    Ng2SmartTableModule,
    NbCardModule,
    NbLayoutModule,
    RecaptchaModule,
    NbSidebarModule.forRoot(),
    CoreModule,
    NbSpinnerModule,
    NbTabsetModule,
    NgChartsModule,
    NbToggleModule,
    NbIconModule,
    NbBadgeModule,
    NbTagModule,
    ReactiveFormsModule,
    TableModule,
    ReportModule
  ],
  providers: [DateFormatPipe, DecimalPipe]
})
export class FeatureModule {
}
